(function(){
  if(window.__cpbConfettiInit) return;
  window.__cpbConfettiInit = true;

  var COLORS = ["#249A96","#53D7D2","#217572","#134644","#ffffff","#f2f2f2","#F7B731","#FF6B6B"];
  var PIECES = 160;

  function fireConfetti(){
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var host = document.querySelector("cart-drawer .drawer__inner") || document.querySelector("cart-drawer") || document.body;
    var r = host.getBoundingClientRect();
    var top = Math.max(r.top, 0);
    var height = r.height && r.height > 0 ? r.height : window.innerHeight;
    var stage = document.createElement("div");
    stage.className = "cpb-confetti";
    stage.setAttribute("aria-hidden", "true");
    stage.style.left = r.left + "px";
    stage.style.top = top + "px";
    stage.style.width = (r.width || window.innerWidth) + "px";
    stage.style.height = height + "px";
    document.body.appendChild(stage);

    for (var i = 0; i < PIECES; i++) {
      var piece = document.createElement("span");
      piece.className = "cpb-confetti__piece";
      var size = 6 + Math.random() * 8;
      piece.style.left = Math.random() * 100 + "%";
      piece.style.top = -12 - Math.random() * 60 + "px";
      piece.style.width = size + "px";
      piece.style.height = size * (0.45 + Math.random() * 0.55) + "px";
      piece.style.background = COLORS[(Math.random() * COLORS.length) | 0];
      if (Math.random() < 0.4) piece.style.borderRadius = "50%";
      stage.appendChild(piece);

      var dx = Math.random() * 260 - 130;
      var rot = Math.random() * 360;
      var spin = 360 + Math.random() * 540;
      var dur = 2600 + Math.random() * 1700;
      var delay = Math.random() * 950;

      piece.animate([
        { transform: "translate(0, 0) rotate(" + rot + "deg)", opacity: 1 },
        { transform: "translate(" + (dx * 0.6) + "px, " + (height * 0.85) + "px) rotate(" + (rot + spin * 0.8) + "deg)", opacity: 1, offset: 0.8 },
        { transform: "translate(" + dx + "px, " + (height + 50) + "px) rotate(" + (rot + spin) + "deg)", opacity: 0 }
      ], {
        duration: dur,
        delay: delay,
        easing: "cubic-bezier(.2,.65,.4,1)",
        fill: "forwards"
      });
    }

    setTimeout(function(){
      if (stage && stage.parentNode) stage.parentNode.removeChild(stage);
    }, 5600);
  }

  window.cpbFireConfetti = fireConfetti;

  var prev = null;
  function check(){
    var bar = document.querySelector("[data-cpb-count]");
    if (bar) {
      var count = parseInt(bar.getAttribute("data-cpb-count") || "0", 10);
      var tiersAttr = bar.getAttribute("data-cpb-tiers");
      var tiers = tiersAttr ? tiersAttr.split(",").map(function(x){ return parseInt(x, 10); }).filter(function(x){ return x > 0; }) : [3, 5];

      if (prev === null) {
        prev = count;
        return;
      }

      if (count > prev) {
        var crossed = false;
        for (var i = 0; i < tiers.length; i++) {
          if (prev < tiers[i] && count >= tiers[i]) {
            crossed = true;
            break;
          }
        }
        if (crossed) {
          fireConfetti();
        }
      }
      prev = count;
    }
  }

  var t;
  var obs = new MutationObserver(function(){
    clearTimeout(t);
    t = setTimeout(check, 120);
  });

  function start(){
    var scope = document.querySelector("cart-drawer") || document.body;
    obs.observe(scope, { childList: true, subtree: true });
    check();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
